const mutations = {
    setSearchParams(state,params){
        state.searchParam=params
    }
}
export default mutations
